import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-detail/menu.module.css';

export const Menu: FC<{}> = ({}) => {
  return (
    <>
      <div className={classes.mypage_common_menu_wrap}>
        <ul className={classes.mypage_common_menu}>
          <li>
            <Link to="/shippingAddress">毎月お届けプランのお届け先変更</Link>
          </li>
          <li>
            <Link to="/paymentMethod">お支払い方法の変更</Link>
          </li>
          <li>
            <a href={`${document.referrer}account/addresses`} target="_parent">
              ご登録情報の確認・変更
            </a>
          </li>
          <li>
            <a href={`${document.referrer}account`} target="_parent">
              ご注文履歴
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};
